var map = {
	".": 38,
	"./": 38,
	"./App": 37,
	"./App.jsx": 37,
	"./App.scss": 105,
	"./App.test": 106,
	"./App.test.js": 106,
	"./assets/images/background.jpg": 462,
	"./assets/images/blue-candy.png": 463,
	"./assets/images/green-candy.png": 464,
	"./assets/images/orange-candy.png": 465,
	"./assets/images/purple-candy.png": 466,
	"./assets/images/red-candy.png": 467,
	"./assets/images/yellow-candy.png": 468,
	"./index": 38,
	"./index.js": 38,
	"./index.scss": 104,
	"./serviceWorker": 67,
	"./serviceWorker.js": 67,
	"./setupTests": 149,
	"./setupTests.js": 149,
	"./utils": 12,
	"./utils.js": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;